/**
 * ランダムで文字列を生成する
 *
 * @param   length (長さ)
 * @return  r (ランダムなStringデータ)
 */
/* eslint-disable */
const randomString = function randomString(length) {
  console.debug('*** Start *** randomString')
  var l = length
  var c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  var cl = c.length
  var r = ''
  for (var i = 0; i < l; i++) {
    r += c[Math.floor(Math.random() * cl)]
  }
  console.debug('*** End *** randomString: ' + r)
  return r
}

export default randomString



// WEBPACK FOOTER //
// ./src/functions/randomString.js